import Referral from "../views/referrral";

export default [
    {
        path: "/referral",
        layout: 'home',
        view: Referral
    }
]
